import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/workspace/layouts/default.vue").then(m => m.default || m)),
  "svg-sprite": defineAsyncComponent(() => import("#build/svg-sprite.vue").then(m => m.default || m))
}